"use strict";
import axios from "axios";

const registerMostViewed = (trends) => {
  axios.post("/api/trends/t", trends);
};

export const mostviewed = () => {
  if (window.trends) {
    registerMostViewed(window.trends);
  }
};

export default mostviewed;
